import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../Icon';

import uuid from '../../scripts/uuidv4';

import './styles.less';

const AccordionItem = (props) => {
    const uniqueId = props.contentId || uuid();
    return (
        <React.Fragment>
            <input
                className="p-accordion__actual-checkbox"
                id={`accordion-${uniqueId}-toggle-${props.accordionIndex}`}
                name={`accordion-${props.accordionId}`}
                defaultChecked={props.isExpanded}
                type={props.autoCollapse ? 'radio' : 'checkbox'}
                disabled={!props.content}
                key={0}
            />
            <label
                className="p-accordion__title-icon-container"
                htmlFor={`accordion-${uniqueId}-toggle-${props.accordionIndex}`}
                key={1}
            >
                <span className="p-accordion__icon-container">
                    <Icon {...props.contractIcon} className="p-accordion__icon p-accordion__icon--contract" />
                    <Icon {...props.expandIcon} className="p-accordion__icon p-accordion__icon--expand" />
                </span>
                <span className="p-accordion__title">{props.title}</span>
            </label>
            <div className="p-accordion__content-container" key={2}>
                <div className="p-accordion__content">{props.content}</div>
            </div>
        </React.Fragment>
    );
};

AccordionItem.propTypes = {
    contentId: PropTypes.string,
    accordionId: PropTypes.string,
    accordionIndex: PropTypes.number,
    title: PropTypes.string,
    content: PropTypes.node,
    expandIcon: PropTypes.shape(Icon.propTypes),
    contractIcon: PropTypes.shape(Icon.propTypes),
    iconPosition: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func,
    isExpanded: PropTypes.bool,
    autoCollapse: PropTypes.bool
};

AccordionItem.defaultProps = {
    accordionId: 'accordion--id',
    accordionIndex: 0,
    title: '',
    content: null,
    iconPosition: 'right',
    isExpanded: false,
    expandIcon: undefined,
    contentId: undefined,
    onClick: undefined,
    autoCollapse: undefined,
    contractIcon: undefined
};

const Accordion = (props) => {
    const uniqueId = props.contentId || uuid();
    const { autoCollapse, expandIcon } = props;
    return (
        <div
            className={classNames({
                'p-accordion': true,
                [`p-accordion--icon-${props.iconPosition}`]: true
            })}
            data-content-id={props.contentId}
        >
            {props.accordionItems.map((elem, i) => {
                const key = i;
                return (
                    <AccordionItem
                        {...elem}
                        key={key}
                        accordionId={uniqueId}
                        accordionIndex={key}
                        autoCollapse={autoCollapse}
                        expandIcon={expandIcon}
                        contractIcon={props.contractIcon}
                    />
                );
            })}
        </div>
    );
};

Accordion.propTypes = {
    accordionItems: PropTypes.arrayOf(PropTypes.shape(AccordionItem.propTypes)),
    autoCollapse: PropTypes.bool,
    contentId: PropTypes.string,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    expandIcon: PropTypes.shape(Icon.propTypes),
    contractIcon: PropTypes.shape(Icon.propTypes)
};

Accordion.defaultProps = {
    accordionItems: [],
    autoCollapse: false,
    contentId: undefined,
    iconPosition: 'right',
    expandIcon: {
        icon: 'arrow-expand'
    },
    contractIcon: {
        icon: 'arrow-contract'
    }
};

export default Accordion;
